module.exports = __webpack_public_path__ + "03d6e72e597e3d65082314e1ffb63ac9.pdf";